export default __webpack_public_path__ + "static/media/Megosu - KarTent - 1.a9b80435.jpg";